import axios from "axios";
import { APIAddress } from "constants/config";
import { STATE } from './updatePoster'

export default function getPosterList(schoolId, poster_state, amount_per_page, page_number, keyword) {
  if(typeof schoolId === 'undefined'){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing school ID')
      })
    })
  }

  if(typeof poster_state === 'undefined'){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing poster state')
      })
    })
  }

  if(!amount_per_page){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing amount per page')
      })
    })
  }

  if(!page_number){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing page number')
      })
    })
  }

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/poster_lst/${schoolId}/${poster_state}/${amount_per_page}/${page_number}?keyword=${keyword? keyword: ''}`,
    'method': 'GET',
    'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/poster/getPosterList.js